import React from 'react';

import { Typography } from '@mui/material';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';

import EmptyTable from 'components/EmptyTable';
import globalMessages from 'translations/messages/global-messages';

function NoResultsFound({ intl, title, details }) {
  return (
    <EmptyTable
      title={
        <Typography variant="body" component="p" align="center" gutterBottom paragraph>
          {title || intl.formatMessage(globalMessages.no_result_found)}
        </Typography>
      }
      subtitle={
        <Typography component="p" variant="subtitleLight" align="center" gutterBottom paragraph>
          {details}
        </Typography>
      }
    />
  );
}

NoResultsFound.propTypes = {
  intl: PropTypes.object.isRequired,
  title: PropTypes.string,
  details: PropTypes.string,
};

export default injectIntl(NoResultsFound);
